module.exports = __webpack_public_path__ + "static/media/steps_icon5.0fe40b62.svg";